module.exports = __webpack_public_path__ + "img/rules_10.61c33b58.png";